export default "__VITE_ASSET__fZysJcsD__"